import { useLogger } from '@booksy-com/vue-tools'
import { useDevConsole } from '@/composables/dev-console/index.js'

const stringify = (args) => {
  let message = args.length > 1 ? args : args[0]

  // shortcut: stringify arrays and objects
  if (message && typeof message === 'object') {
    return JSON.stringify(message)
  }
  return message
}

export const useDevLogger = (name) => {
  const logger = useLogger(name)
  const devConsole = useDevConsole()

  const debug = (...args) => {
    logger.debug(...args)
    devConsole.logText(`[${name}] ${stringify(args)}`)
  }

  const error = (...args) => {
    logger.error(...args)
    devConsole.logError(`[${name}] ${stringify(args)}`)
  }

  return {
    debug,
    error,
  }
}
